import { useContext, useEffect, useState } from "react";
import { useStyles } from "./doctors-dropdown-container.styles";
import ActiveContext from "../../Context/Context";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useAddDoctor } from "../../features/doctors/hooks/use-add-doctor";
import { useDoctorsMenu } from "../../features/doctors/hooks/use-doctors-menu";
import AddDoctorForm from "../../features/doctors/components/add-doctor-form.component";
import { useGetDoctors } from "../../features/doctors/hooks/use-get-doctors";

const DoctorsDropdownContainer = ({
  setSelectedDoctor,
  selectedDoctor,
  setEnableDialog,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { clinicData, showAddForm, setShowAddForm } = useContext(ActiveContext);

  const shouldFetchDoctors =
    !clinicData?.doctors && !clinicData?.data?.clinic_info?.doctors;
  const { data: doctors, isFetching } = useGetDoctors(shouldFetchDoctors);
  const {
    mutate: addDoctor,
    isLoading: isAddingDoctor,
    isError,
  } = useAddDoctor();
  const { doctorsMenu, addDoctorToMenu } = useDoctorsMenu(doctors, clinicData);
  const handleChange = (selectedOption) => {
    if (selectedOption?.value === "add_new") {
      setShowAddForm(true);
      setSelectedDoctor("");
    } else {
      setSelectedDoctor(selectedOption?.value || "");
      setShowAddForm(false);
    }
  };

  const handleAddDoctor = (firstName, lastName) => {
    const fullName = `Dr. ${firstName} ${lastName}`;

    addDoctor(fullName, {
      onSuccess: () => {
        addDoctorToMenu(fullName);
        setSelectedDoctor(fullName);
        setShowAddForm(false);
      },
      onError: () => {
        setShowAddForm(false);
      },
    });
  };

  useEffect(() => {
    if (doctorsMenu.length === 2) {
      setSelectedDoctor(doctorsMenu[0].value);
    }
  }, [doctorsMenu, setSelectedDoctor]);

  useEffect(() => {
    setEnableDialog(selectedDoctor !== "");
  }, [selectedDoctor, setEnableDialog]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
    option: (base, state) => ({
      ...base,
      ...(state.data.value === "add_new"
        ? {
            color: "gray",
          }
        : {}),
    }),
  };

  return (
    <div className={classes.dropdownContainer}>
      {!showAddForm ? (
        <>
          <Select
            options={doctorsMenu}
            value={doctorsMenu.find(
              (option) => option.value === selectedDoctor,
            )}
            onChange={handleChange}
            isLoading={isFetching}
            placeholder={t("doctors-dropdown-label")}
            isSearchable
            isClearable
            menuPosition="fixed"
            menuPlacement="auto"
            styles={customStyles}
          />
          {isError && (
            <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
              {t("doctor-add-failed")}
            </div>
          )}
        </>
      ) : (
        <AddDoctorForm
          onAdd={handleAddDoctor}
          onCancel={() => setShowAddForm(false)}
          isLoading={isAddingDoctor}
        />
      )}
    </div>
  );
};

export default DoctorsDropdownContainer;
